import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { bindMenu, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';
import { useTranslation } from 'react-i18next';

import { useCopyFileUrl } from 'src/hooks/useCopyFileUrl';
import { UploadedFile } from 'src/interfaces/FileManager';

type FileRowActionsProps = {
  file: UploadedFile;
  onEdit: (file: UploadedFile) => void;
  onDelete: (fileId: string) => void;
};

export function FileRowActionsMenu({ file, onEdit, onDelete }: FileRowActionsProps) {
  const { t } = useTranslation();
  const copyFileUrl = useCopyFileUrl();
  const actionsMenu = usePopupState({ variant: 'popover', popupId: `file-actions-${file.id}` });

  return (
    <>
      <IconButton
        size="small"
        {...bindTrigger(actionsMenu)}
        aria-label={t('technicalTypes.optionsLabel')}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu {...bindMenu(actionsMenu)}>
        <MenuItem
          onClick={() => {
            onEdit(file);
            actionsMenu.close();
          }}
        >
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t('base.edit')}</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            void copyFileUrl(file.fileUrl);
            actionsMenu.close();
          }}
        >
          <ListItemIcon>
            <ContentCopyIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t('system.fileManager.copyLink')}</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            onDelete(file.id);
            actionsMenu.close();
          }}
        >
          <ListItemIcon>
            <DeleteIcon color="error" fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t('base.delete')}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
